import React, { useState, useEffect } from 'react';

const SpaceCard = ({ space }) => {
  const [imageError, setImageError] = useState(false);
  const [imageSrc, setImageSrc] = useState(space.image);

  // Check if image exists on load
  useEffect(() => {
    const img = new Image();
    img.src = space.image;

    img.onload = () => {
      setImageSrc(space.image);
      setImageError(false);
    };

    img.onerror = () => {
      console.error(`Failed to load image: ${space.image}`);
      setImageError(true);
    };
  }, [space.image]);

  return (
    <div className="space-item">
      <div className="image-container">
        {imageError ? (
          <div className="image-placeholder">Obrázek nenalezen</div>
        ) : (
          <img
            src={imageSrc}
            alt={space.alt}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div className="space-description">
        <h3>{space.name}</h3>
        <p>{space.description}</p>
      </div>
    </div>
  );
};

export default SpaceCard;
